import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'documentType'
})
export class DocumentTypePipe implements PipeTransform {

  transform(value: any, args?: 'full'): string {
    if(args && args == 'full') {
      const fullDescriptions = {
        'N': 'Nit',
        'C': 'Cédula de Ciudadania',
        'E': 'Cédula de Extranjería',
      };

      return fullDescriptions[value];
    }
    
    switch (value) {
      case 'N':
        return 'Nit';
        break;
      case 'C':
        return 'CC';
        break;
      case 'E':
        return 'CE';
        break;
        case 'P':
      return 'Pasaporte';
      break;

      case 'C.C.':
        return 'C.C. CÉDULA DE CIUDADANIA';
        break;
      case 'C.E.':
        return 'C.E. CÉDULA DE EXTRANJERIA';
        break;

      default:
        return value;
        break;
    }
  }

}
